import React from "react";
import { motion } from "framer-motion";
import standard from "../assets/img/standard2.jpg";
import express from "../assets/img/express3.png";
import bulk from "../assets/img/bulk.png";
import project from "../assets/img/project2.jpg";
import international from "../assets/img/internationalshipping.jpg";
import custom from "../assets/img/customdelivery.png";

const servicePackages = [
  {
    id: 1,
    image: standard,
    heading: "Standard Delivery",
    paragraph:
      "Rely on our on-site delivery services, reaching you anywhere, anytime.",
  },
  {
    id: 2,
    image: express,
    heading: "Express Delivery",
    paragraph:
      "Accelerate shipping for urgent orders, minimizing project downtime.",
  },
  {
    id: 3,
    image: bulk,
    heading: " Bulk Order Delivery",
    paragraph:
      "Save more on bulk orders with efficient, cost-effective logistics tailored for large-scale projects and wholesale buyers.",
  },
  {
    id: 4,
    image: project,
    heading: "Project-Based Supply",
    paragraph:
      "Schedule deliveries that align with your construction timeline.",
  },
  {
    id: 5,
    image: international,
    heading: "International Shipping",
    paragraph: "Secure global exports with hassle-free logistics.",
  },
  {
    id: 6,
    image: custom,
    heading: "Custom Delivery Plans",
    paragraph: "Tailor solutions built around your specific needs.",
  },
];

function WeServe() {
  return (
    <div className="pt-5 h-auto text-center font-serif">
      <h2 className="font-bold text-primary text-[0.9rem] md:text-xl mb-4 px-3">
        Your Power, Your Project, Our Timely Cable Supply.
      </h2>
      <h2 className="font-bold text-black text-lg md:text-3xl mb-5 px-3">
        Delivery Services
      </h2>
      <p className="px-5 md:px-40 lg:px-80 text-gray-600 max-[450px]:text-[1rem]">
        Timely delivery is critical in the building and construction industry.
        We ensure your projects stay on schedule with fast, reliable, and
        flexible delivery options:
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 mt-3 md:mt-10 py-10 md:py-7 justify-center lg:mx-10">
        {servicePackages?.map((item) => (
          <motion.div
            key={item?.id}
            initial={{
              translateY: -100,
              opacity: 0,
            }}
            whileInView={{
              translateY: 0,
              opacity: 1,
            }}
            transition={{
              duration: 1,
            }}
            className="flex flex-col items-center gap-4 py-5 lg:px-6 rounded shadow-lg shadow-gray-300 mx-7 md:mx-6"
          >
            <div>
              <img src={item?.image} alt="" className="w-[12rem] rounded-lg" />
            </div>
            <h2 className="font-semibold">{item?.heading}</h2>
            <p className="text-base text-gray-700 px-[1.5rem]">
              {item?.paragraph}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default WeServe;
